export class CSVConverter {
  public fromJSONArray(jsarray: any[]) {
    const header = Object.keys(jsarray[0]);
    const body = jsarray.map((item) => {
      let line = [];
      for (let k of header) {
        line.push(item[k]);
      }
      return line.join('|');
    });
    return header.join('|') + '\n' + body.join('\n');
  }
}
